import React from "react";
import { Box, Grid, TextField, Button, MenuItem } from "@mui/material";
import { Add, Search } from "@mui/icons-material";
import { CONTACT_TYPES } from "./ContactFormDialog";
import { useTranslation } from "react-i18next";

export default function ContactsToolbar({ query, onQuery, typeFilter, onTypeFilter, onNew }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            placeholder={t("contactsToolbar.searchPlaceholder", "Search name / email / phone")}
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            InputProps={{
              startAdornment: <Search fontSize="small" sx={{ mr: 1, opacity: 0.6 }} />
            }}
          />
        </Grid>

        <Grid item xs={7} md={4}>
          <TextField
            select
            fullWidth
            size="small"
            label={t("contactsToolbar.typeLabel", "Type")}
            value={typeFilter}
            onChange={(e) => onTypeFilter(e.target.value)}
          >
            <MenuItem value="">{t("contactsToolbar.typeAll", "All")}</MenuItem>
            {CONTACT_TYPES.map((ct) => (
              <MenuItem key={ct.value} value={ct.value}>
                {t(`contactFormDialog.types.${ct.value}`, ct.label)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={5} md={2} sx={{ textAlign: { xs: "right", md: "right" } }}>
          <Button startIcon={<Add />} variant="contained" onClick={onNew}>
            {t("contactsToolbar.actions.new", "New")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
